"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceSetting = exports.CreateDeviceSettingMetadata = exports.DeviceSettingMetaKeys = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
var DeviceSettingMetaKeys;
(function (DeviceSettingMetaKeys) {
    DeviceSettingMetaKeys["AUTO_PRINT"] = "autoPrint";
    DeviceSettingMetaKeys["PRINTING_VERSION"] = "printingVersion";
    DeviceSettingMetaKeys["UBER_EATS_ORDER_ALERT"] = "uberEatsOrderAlert";
})(DeviceSettingMetaKeys || (exports.DeviceSettingMetaKeys = DeviceSettingMetaKeys = {}));
class CreateDeviceSettingMetadata {
}
exports.CreateDeviceSettingMetadata = CreateDeviceSettingMetadata;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(DeviceSettingMetaKeys),
    (0, class_transformer_1.Expose)()
], CreateDeviceSettingMetadata.prototype, "metaKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CreateDeviceSettingMetadata.prototype, "metaValue", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CreateDeviceSettingMetadata.prototype, "metaType", void 0);
class DeviceSetting extends CreateDeviceSettingMetadata {
}
exports.DeviceSetting = DeviceSetting;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], DeviceSetting.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], DeviceSetting.prototype, "locationId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], DeviceSetting.prototype, "deviceId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)()
], DeviceSetting.prototype, "createDate", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)()
], DeviceSetting.prototype, "updateDate", void 0);
//# sourceMappingURL=deviceSettings.js.map